import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  const whatsappNumber = "918973739377";

  const handleClick = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=Hi! I found your services through your website. I'd like to schedule a consultation. Please let me know how to proceed.`, "_blank");
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={handleClick}
        className="bg-green-500 hover:bg-green-600 text-white rounded-full p-2 md:p-4 shadow-lg"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="text-2xl" />
      </button>
    </div>
  );
};

export default WhatsAppButton;
